export default {
  created() {
    // listen messages from social popup
    window.addEventListener('message', this.receiveMessage, false)
  },
  destroyed: function () {
    // remove listener for messages from social popup
    window.removeEventListener('message', this.receiveMessage, false)
  },
  data() {
    return {
      popup: null,
      popupCheck: null,
      popupWidth: 600,
      popupHeight: 560,
    }
  },

  methods: {
    // Create Window to login on network
    launchSocialLogin(network) {
      this.is_social_loading = true

      var left = screen.width / 2 - this.popupWidth / 2
      var top = screen.height / 2 - this.popupHeight / 2
      var url = (process.env.NODE_ENV === 'production' ? '' : process.env.VUE_APP_URL) + '/' + network
      var config = 'toolbar=no, location=no, status=no, menubar=no, scrollbars=no'
      this.popup = window.open(
        url,
        'Facebook',
        config + ', width=' + this.popupWidth + ', height=' + this.popupHeight + ', top=' + top + ', left=' + left
      )

      this.popupCheck = setInterval(() => {
        if (this.popup.closed) {
          clearInterval(this.popupCheck)
          this.is_social_loading = false
        }
      }, 400)
    },

    // receive message from login window on social media
    receiveMessage(event) {
      const { data } = event
      if (data.is_social_connect) {
        this.is_social_loading = false

        if (data.facebook) {
          this.fb_user_profile = data.facebook
          this.fb_user_pages = data.facebook.pages
          this.fb_ads_accounts = data.facebook.ads_accounts
          this.is_ig_business_conected = true
          this.selected_fb_page = false
          this.$store.commit('auth/AUTH_FB')
        }

        if (data.instagram) {
          this.ig_user_profile = data.instagram
        }

        // show laravel messages, if available
        if (data.message) {
          this.$message({
            showClose: true,
            message: data.message.message,
            type: data.message['message-type'],
          })
        }

        // close popup
        if (this.popup) {
          this.popup.close()
          clearInterval(this.popupCheck)
        }

        if (this.$route.name === 'social') {
          this.$emit('update')
        }
      }
    },
  },
}
